import { BlogBreadcrumbs } from '@/components/marketing/blog-breadcrumbs'
import { useLocation } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { blogPostByPath, blogDate, readingMinutes } from '@/config/blog/posts'
import { getAppUrl } from '@/config/marketing-nav.config'
import { HeroTitle } from '@/components/marketing/hero-title'
import { CtaBand } from '@/components/marketing/cta-band'
import { NotFoundPage } from './NotFoundPage'
import '@/styles/blog.css'

export function BlogPostPage() {
  const { pathname } = useLocation()
  const post = blogPostByPath[pathname.replace(/\/+$/, '')]
  if (!post) return <NotFoundPage />
  const signup = `${getAppUrl('/signup')}?utm_source=blog&utm_medium=article&utm_campaign=${encodeURIComponent(post.slug)}`
  return (
    <main className="blog">
      <article className="marketing-container blog-article">
        <BlogBreadcrumbs path={pathname} />
        <header>
          <div className="blog-meta">
            <span className="blog-category">{post.category}</span>
            <time dateTime={post.published_at}>
              {blogDate(post.published_at)}
            </time>
            <span>{readingMinutes(post.content)} min read</span>
          </div>
          <HeroTitle className="newsroom-hero__title">{post.title}</HeroTitle>
          <p className="blog-byline">By {post.author.name}</p>
        </header>
        <div className="blog-prose">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            skipHtml
            components={{
              table: ({ children }) => (
                <div className="blog-table-scroll">
                  <table>{children}</table>
                </div>
              ),
              a: ({ href, children }) => (
                <a href={href} rel="noopener noreferrer">
                  {children}
                </a>
              ),
              h1: ({ children }) => <h2>{children}</h2>,
            }}
          >
            {post.content}
          </ReactMarkdown>
        </div>
        <footer className="blog-author">
          <p className="blog-eyebrow">ABOUT THE AUTHOR</p>
          <h2>{post.author.name}</h2>
          <p>{post.author.bio}</p>
          <p className="blog-updated">Updated {blogDate(post.updated_at)}</p>
          {post.tags.length > 0 && (
            <div className="blog-tags">
              {post.tags.map((tag) => (
                <span key={tag}>{tag}</span>
              ))}
            </div>
          )}
        </footer>
      </article>
      <CtaBand
        title="Put the market in perspective."
        lead="Meet Ivy. Connect your research, market data, and portfolio in one place."
        primaryLabel="Get started with Ivy"
        primaryHref={signup}
      />
    </main>
  )
}
